module.exports = __webpack_public_path__ + "TurboTilesPattern.png";